import React, { useState } from "react";
import { ResponseSavedGroups } from "@/features/auth/types/auth";
import styles from "./ModalSaveModeGroupsModal.module.scss";

interface ModalSaveModeGroupsModalProps {
  apiDataSavedGroupsFilter: ResponseSavedGroups | undefined;
  filterValueGroup: string;
  handleFilterGroup: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddGroup: () => void;
  handleClickGroup: (idGroup: number, screens: string[]) => Promise<void>;
  onCreateNewGroup: (groupName: string) => Promise<void>;
  isCreatingGroup: boolean;
}

const ModalSaveModeGroupsModal = React.forwardRef<
  HTMLDivElement,
  ModalSaveModeGroupsModalProps
>(
  (
    {
      apiDataSavedGroupsFilter,
      filterValueGroup,
      handleFilterGroup,
      handleAddGroup,
      handleClickGroup,
      onCreateNewGroup,
      isCreatingGroup,
    },
    ref,
  ) => {
    const [showAddGroupPopup, setShowAddGroupPopup] = useState<boolean>(false);
    const [groupName, setGroupName] = useState<string>("");

    const handleCreateGroup = async () => {
      if (groupName.trim()) {
        await onCreateNewGroup(groupName.trim());
        setShowAddGroupPopup(false);
        setGroupName("");
      }
    };

    return (
      <div ref={ref} className={styles.root}>
        <div
          onClick={() => setShowAddGroupPopup(!showAddGroupPopup)}
          className={styles.groupSaveBtn}
        >
          <button>
            <img src="/img/whiteIcon/PlusBold.svg" alt="plusGroupModalImg" />
            <span>Add new group</span>
          </button>
        </div>
        <div className={styles.lineContainer}>
          <div className={styles.line} />
        </div>
        <div className={styles.groupSaveBottom}>
          {apiDataSavedGroupsFilter?.results.map((item) => {
            const screens = item.saved_points.map((point) => point.screen);
            const screensStore = item.saved_store_screens.map((storeScreen) => {
              return storeScreen.store_screen?.thumbnail || "";
            });

            const allScreens = [...screens, ...screensStore];

            return (
              <div className={styles.groupSaveItem} key={item.id}>
                <p onClick={() => handleClickGroup(item.id, allScreens)}>
                  {item.name}
                </p>
              </div>
            );
          })}
        </div>

        {showAddGroupPopup && (
          <div className={styles.addGroupPopup}>
            <div className={styles.addGroupPopupContainer}>
              <div className={styles.addGroupPopupContainerHeader}>
                <img src="/img/whiteIcon/NewGroup.svg" alt="New Group" />
                <p>Add new group</p>
              </div>
              <div className={styles.addGroupPopupInputContainer}>
                <input
                  type="text"
                  placeholder="Group name"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleCreateGroup()}
                />
                <button
                  onClick={handleCreateGroup}
                  disabled={isCreatingGroup || !groupName.trim()}
                >
                  {isCreatingGroup ? "Adding..." : "Add"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  },
);

export default ModalSaveModeGroupsModal;
